module.exports = __webpack_public_path__ + "static/media/kalam-bold-webfont.56925667.woff2";